// extracted by css-extract-rspack-plugin
export default {"page":"CalendarPage_page__Tfl4+","progressWrapper":"CalendarPage_progressWrapper__xN0xU"};